import { Link } from "react-router-dom";
import ResponsiveButton from "../../components/ResponsiveButton/ResponsiveButton";
import { trackEvent } from "../../utils/analytics";
import logo from "../../assets/new_logo.webp";

const aboutChips = [
  "Kerava",
  "Äänentoisto",
  "Valotekniikka",
  "Kuljetus & asennus",
];

const About = () => {
  return (
    <section
      data-aos="fade-up"
      className="
        relative overflow-hidden py-20
        bg-gradient-to-br from-white via-[#F3FFFC] to-[#E9FBF7]
        dark:from-[#050505] dark:via-[#08080A] dark:to-[#0D0D12]
      "
      aria-labelledby="about-heading"
    >
      <div className="mx-auto max-w-7xl px-4">
        <div
          className="
            grid grid-cols-1 items-center gap-10
            rounded-[2rem] border border-[#DDE7E5] bg-white p-6 shadow-xl
            dark:border-darkborder dark:bg-[#111114]
            sm:grid-cols-2 md:p-8
          "
        >
          {/* Logo */}
          <div data-aos="fade-right" className="flex justify-center">
            <div
              className="
                relative flex h-64 w-64 items-center justify-center rounded-[2rem]
                border border-[#DDE7E5] bg-[#F8FAFC]
                dark:border-darkborder dark:bg-darksurface
              "
            >
              <div
                aria-hidden="true"
                className="
                  absolute inset-8 rounded-full bg-primary/15 blur-3xl
                  dark:bg-primary/10
                "
              />

              <img
                src={logo}
                alt="Spiderlegs Productionsin logo"
                title="Spiderlegs Productionsin logo"
                loading="lazy"
                className="
                  relative z-10 max-h-[210px] w-auto object-contain
                  drop-shadow-[0_18px_22px_rgba(0,0,0,0.25)]
                "
              />
            </div>
          </div>

          {/* Teksti */}
          <div className="space-y-5">
            <div className="flex flex-wrap gap-2">
              {aboutChips.map((chip) => (
                <span
                  key={chip}
                  className="
                    inline-flex rounded-full border border-[#DDE7E5] bg-[#F8FAFC]
                    px-4 py-2 font-customFont1 text-sm font-semibold
                    !text-[#111827]
                    dark:border-darkborder dark:bg-darksurface dark:!text-white
                  "
                >
                  {chip}
                </span>
              ))}
            </div>

            <h2
              id="about-heading"
              data-aos="fade-up"
               className="
                font-customFont2 text-left text-3xl sm:text-3xl md:text-5xl lg:text-6xl xl:text-7xl font-bold leading-snug
                text-text
                dark:text-darktext
              "
            >
              Tietoa meistä
            </h2>

            <p
              data-aos="fade-up"
              className="
                max-w-2xl font-customFont1 text-left text-lg font-normal
                leading-relaxed !text-[#374151]
                dark:!text-[#D1D5DB]
                xl:text-xl
              "
            >
              Spiderlegs Productions on Keravalla, Keski-Uudellamaalla toimiva
              tapahtumatekniikan ja laitevuokrauksen palvelu. Tarjoamme
              selkeitä ratkaisuja äänentoistoon, valotekniikkaan, kuljetukseen
              ja asennukseen.
            </p>

            <p
              data-aos="fade-up"
              className="
                max-w-2xl font-customFont1 text-left text-lg font-normal
                leading-relaxed !text-[#374151]
                dark:!text-[#D1D5DB]
                xl:text-xl
              "
            >
              Tavoitteena on tehdä tekniikan vuokraamisesta mahdollisimman
              vaivatonta: valitset sopivat laitteet, lähetät varauksen ja saat
              selkeät ohjeet toteutukseen.
            </p>

            <div data-aos="fade-up" className="pt-2">
              <Link
                to="/meista"
                onClick={() => {
                  trackEvent("siirtyi_meista_sivulle", {
                    lahto: "etusivu_about",
                  });
                  window.scrollTo({ top: 0, left: 0, behavior: "instant" });
                }}
                aria-label="Siirry Tietoa meistä -sivulle"
              >
                <ResponsiveButton variant="seemore">Lue lisää</ResponsiveButton>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;